import { Message,MessageBox } from "element-ui"
import JsEncrypt from 'jsencrypt'
import Vue from 'vue'
import store  from '../store'
export const catchErr = function(err) {
  if(!err || (!err.code && err.constructor !== Error)) return Promise.reject()
  store.state.axiosList.find(axios => {
    console.log(axios.$$url, err.config.url)
    if(axios.$$url === err.config.url) {
      axios.$$state = 'rejected'
      return true
    }
  })
  store._mutations.updateLoadingState[0]({
    state: false
  })
  if(err.code === 999) {
    Message.error('登录状态已过期，请重新登录')
    this.$router.replace('/login')
  }else {
    if(err.constructor === Error) {
      MessageBox.confirm(`
        <p>系统内部错误，请联系开发人员</p>
        <p style="font-size:12px;color:#a5a5a5;word-break:break-all">时间：${new Date()} 消息：${err.response.data.path} ${err.response.data.message}</p>
      `,'错误提示',{
        dangerouslyUseHTMLString: true
      })
    } else {
      Message.error(err.message)
    }
    return Promise.reject()
  }
}


export const cookie = {
  set: function (name, value, days) {
    var domain, domainParts, date, expires, host;
    if (days) {
      date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }
    const href = location.href
    if(process.env.NODE_ENV === "development") {
      document.cookie = name + "=" + value + "; path=/"
    } else {
      document.cookie = name + "=" + value + "; path=/; domain=.ccqf.vip";
    }
  },
  get: function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1, c.length);
      }

      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },

  erase: function (name) {
    Cookie.set(name, '', -1);
  }
}

export const getArrProp = (arr,p) => {
  const arr1 = []
  arr.forEach(item => {
    arr1.push(item[p])
  })
  return arr1
}


export const classPropAssign = function(items,params) {
  items.forEach(arr => {
    this[arr[0]] = params && params[arr[0]] ? params[arr[0]] : arr[1]
  })
}

export const deepClone = data => {
  return JSON.parse(JSON.stringify(data))
}

export const encruption = pwd => {
  const encrypt = new JsEncrypt()
  encrypt.setPublicKey('MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgBEOoiPWvS+iCJ7tLbq9d3/ssoB4K4PsfTqqjG22E+59CxvfETSoLOL8UERJPeCRLnM6kfAkmQi5/xqmAbqyMaAVoINRCAHEkGJxwA6rxXCmdgspfKIwHzWlmOj8BYH09uLtdbWS0CwZ1sFtoI+sHp200lvMyq+p6gjilh5/kbJa/YftXAyZAc4hIP0b+jIATYuB5Z1JNjCJMrSRYqnqZEMluTImi7+W+3bQNcex/agRkwqY44RXxiykJEpXFtgeteDGePr1GPi8KMQ9gzKzFj5lb0ih3A4LFgVoyHvDGaeeFoT82AXch/Mt081v9kD5Ce7JXedopYLOvZ2WK7kpiwIDAQAB')
  return encrypt.encrypt(pwd)
}


// WEBPACK FOOTER //
// ./src/util/index.js